export const ClockIcon = ({ classname }: { classname?: string }) => (
  <svg
    className={classname}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4318_4503)">
      <path
        d="M7.99967 14.6632C11.6816 14.6632 14.6663 11.6784 14.6663 7.9965C14.6663 4.3146 11.6816 1.32983 7.99967 1.32983C4.31778 1.32983 1.33301 4.3146 1.33301 7.9965C1.33301 11.6784 4.31778 14.6632 7.99967 14.6632Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8 3.99658V7.99658L10.6667 9.32992"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4318_4503">
        <rect
          width="16"
          height="16"
          fill="currentColor"
          transform="translate(0 -0.00341797)"
        />
      </clipPath>
    </defs>
  </svg>
);
